import React, { useContext } from 'react'
import muralikrishna from '../assets/Muralikrishna.png';
import Type from './Type';
import cv from './MURALI_KRISHNA.pdf'; 
import "./Portfolio.css"
import { UserContext } from '../App';
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedin } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { BsFillPersonVcardFill } from "react-icons/bs";
import { TfiDownload } from "react-icons/tfi";
import Skills from './skills/skills';
import Exp from './experiance/exp';
import Certify from './certifications/certify';
import {motion} from 'framer-motion';
import {fadeIn} from './variants'
import { useParams } from 'react-router-dom';


function Portfolio() {
  const {theme,setTheme,padding,setPadding}= useContext(UserContext);

  
  return (
    

    <div className='main-topp' style={{backgroundColor:theme==0?"#f9f9f9":"black"}}>
    <div className='main-portfolio' style={{paddingTop:"10rem",backgroundColor:theme==0?"#f9f9f9":"black",paddingBottom:"0rem"}}>
      <div id='intro-1' style={{marginTop:padding==0?"0.7rem":"3rem"}}>
        
        <div style={{display:"flex",flexDirection:"column"}}>
        <div>

        <p style={{color:theme==0?"black":"white"}}>Hello Welcome , 
            <div  style={{fontSize:"3rem" , fontWeight:"bolder"}} >
            <span style={{color:theme==0?"black":"white"}} id="im">I'm a</span>&nbsp;
               <div id={theme==0?"type-light":"type-dark"} style={{display:"inline-block"}}>
               <Type/>
               </div>
            
            </div>
        </p>
        </div>
        <p  className='about' style={{color:"grey",marginBottom:"30px"}}>
        As a versatile Full Stack Web Developer with a strong focus on UI/UX design, I blend creativity and technical expertise to craft seamless, interactive web experiences. My portfolio highlights a range of projects where I've utilized modern technologies and design principles to build visually appealing and functional websites.
        </p>
        </div>
        <div  className='btns' >
          <motion.button  
                        id={theme==0?"btn-light":"btn-dark"}
                        variants={fadeIn("up",0.2)}
                        initial="hidden"
                        whileInView={"show"}
                        viewport={{once:false,amount:0.7}}
          className={theme==0?"hire-light":"hire-dark"}><a href='#talk'><BsFillPersonVcardFill/>Hire Me</a></motion.button>
          <motion.button 
                        variants={fadeIn("up",0.2)}
                        initial="hidden"
                        whileInView={"show"}
                        viewport={{once:false,amount:0.7}}
          className={theme==0?"resume-light":"resume-dark"}> <a href={cv} download> Resume CV <TfiDownload/></a></motion.button>
        </div>

      </div>
      <motion.div
              variants={fadeIn("down",0.2)}
              initial="hidden"
              whileInView={"show"}
              viewport={{once:false,amount:0.7}}
            
       className='social-icons' id={theme==0?"socials-light":"socials-dark"} style={{color:theme==0?"black":"white",gap:"1rem"}}>
          <span id={theme==0?"card-light":'card-dark'}><a href="https://github.com/Muralikrishnapopuri" target='_blank'><AiFillGithub/></a></span>
         <span id={theme==0?"card-light":'card-dark'}> <a href="https://www.linkedin.com/in/popuri-murali-krishna-90b112239/" target='_blank'><FaLinkedin/></a></span>
          <span id={theme==0?"card-light":'card-dark'}><a href="https://www.instagram.com/unknown/" target='_blank'><FaInstagram/></a></span>
          
        </motion.div>
      <div id="intro-2" >
        <img  src={muralikrishna} alt="murali krishna" title="Murali krishna" />
      </div>

      
      
    
    </div>
    <Skills/>
    <Exp/>
    <Certify/>
    <span  id="talk" style={{margin:"0px",padding:"0px"}}></span>
    </div>
    
   


    
  )
}

export default Portfolio
